<template>
  <div :class="['table-layout-cell', xAlign ? `table-layout-cell-x-align-${xAlign}` : null, yAlign ? `table-layout-cell-v-align-${yAlign}` : null]">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Cell',
  props: {
    /**
     * Apply CSS text-align ('left'|'center'|'right')
     */
    xAlign: {
      type: String,
      required: false
    },
    /**
     * Apply CSS vertical-align ('top'|'middle'|'bottom'|'baseline')
     */
    yAlign: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Handler for the mounted callback of the component
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      if (!this.$parent.$el.classList.contains('table-layout-row')) {
        console.warn('The <cell /> element should be nested inside a <row /> component.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table-layout/cell.vue